import fr from "./fr.json";
import gr from "./gr.json";
import en from "./en.json";

export const languages = {
  EN: en,
  FR: fr,
  GR: gr,
};
